(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeGroupConfigDataStore',
		[
			'$q',
			'smbUserGroupFilterService',
			'smbLibraryConfigService',
			'smbContentTypeGroupConfigService',
			'smbAclService',
			'smbContentTypeGroupTagTypeConfigService',
			ContentTypeGroupDataStore
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeGroupConfigDataStore
	 *
	 * @description
	 * A data store for managing local content type groups state for
	 * the configuration section.
	 */
	function ContentTypeGroupDataStore($q, smbUserGroupFilterService, smbLibraryConfigService, smbContentTypeGroupConfigService, smbAclService, smbContentTypeGroupTagTypeConfigService) {
		var _contentTypeGroup = null;
		var _contentTypeGroupDetails = null;

		var _userGroupsWithViewRights = null;
		var _userGroupsWithFullRights = null;

		var _newContentTypeGroup = {
			ContentTypeGroupName: '',
			Icon: ''
		};

		// Create the following Status related indexes when creating a Library and assign to itself
		var _contentStatus = {
			TagTypeName: '&&_AirBase_Content_Status',
			DataType: 0
		};

		var _todoStatus = {
			TagTypeName: '&&_AirBase_ToDo_Status',
			DataType: 0
		};

		var _assignedUserId = {
			TagTypeName: '&&_AirBase_Assigned_UserId',
			DataType: 1
		};

		var _assignedDate = {
			TagTypeName: '&&_AirBase_Assigned_Date',
			DataType: 2
		};

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypeGroupConfigDataStore#getContentTypeGroup
			 * @propertyOf smb-app.smbContentTypeGroupConfigDataStore
			 * @kind property
			 *
			 * @description
			 * The currently selected content type group.
			 */
			getContentTypeGroup: getContentTypeGroup,

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupConfigDataStore#saveContentTypeGroup
			 * @methodOf smb-app.smbContentTypeGroupConfigDataStore
			 * @kind function
			 *
			 * @description
			 * Add/Edit a content type group in the system.
			 *
			 * @param {Object} group An object that represents a new content type group
			 * @param {String} group.id The id of the group being edited (only for edit)
			 * @param {String} group.name The name of the new content type group
			 * @param {String} group.icon The name of the selected icon for the new content type group
			 */
			saveContentTypeGroup: saveContentTypeGroup,

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupConfigDataStore#assignUserGroupsToContentTypeGroup
			 * @methodOf smb-app.smbContentTypeGroupConfigDataStore
			 * @kind function
			 *
			 * @description
			 * Assign User Groups to Content Type Group
			 *
			 * @param {Object} group An object that represents a new content type group
			 * @param {String} group.id The id of the group being edited (only for edit)
			 * @param {String} group.name The name of the new content type group
			 * @param {String} group.icon The name of the selected icon for the new content type group
			 */
			assignUserGroupsToContentTypeGroup: assignUserGroupsToContentTypeGroup,

			get contentTypeGroup() { return _contentTypeGroup; },

			get contentTypeGroupDetails() { return _contentTypeGroupDetails; },

			get userGroupsWithViewRights() { return smbUserGroupFilterService.getUserGroupsWithViewRights(); },

			get userGroupsWithFullRights() { return smbUserGroupFilterService.getUserGroupsWithFullRights(); },

			get userGroupsWithEditRights() { return smbUserGroupFilterService.getUserGroupsWithEditRights(); },

			saveUserGroups: saveUserGroups
		};

		function getContentTypeGroup(contentTypeGroupId) {
			if (!contentTypeGroupId) {
				_contentTypeGroup = angular.copy(_newContentTypeGroup);
				_contentTypeGroupDetails = [];

				smbUserGroupFilterService.filterUserGroups(_contentTypeGroupDetails);

				return $q.resolve(_contentTypeGroup);
			}
			return smbLibraryConfigService
				.getLibrary(contentTypeGroupId)
				.then(function (response) {
					_contentTypeGroup = response;
					return response;
				})
				.then(function (contentTypeGroup) {
					return smbLibraryConfigService
						.getLibraryDetails(contentTypeGroup);
				})
				.then(function (details) {
					_contentTypeGroupDetails = details;

					smbUserGroupFilterService.filterUserGroups(details);

					return _contentTypeGroup;
				});

		}

		function saveContentTypeGroup(contentTypeGroup)
		{
			var lib = null;
			if (contentTypeGroup.id) {
				lib = { LibraryId: contentTypeGroup.id, LibraryName: contentTypeGroup.name, IconId: contentTypeGroup.icon };
				return smbContentTypeGroupConfigService.editContentTypeGroup(lib)
					.then(function (response) {
						_contentTypeGroup = response;
						return response;
					});
			}
			else {
				lib = { LibraryName: contentTypeGroup.name, IconId: contentTypeGroup.icon };
				return smbContentTypeGroupConfigService.createContentTypeGroup(lib)
					.then(function (response) {
						_contentTypeGroup = response;
						return response;
					})
					.then(function createContentStatus() {
						return smbContentTypeGroupTagTypeConfigService.createTagType(_contentTypeGroup.LibraryId, _contentStatus);
					})
					.then(function createToDoStatus() {
						return smbContentTypeGroupTagTypeConfigService.createTagType(_contentTypeGroup.LibraryId, _todoStatus);
					})
					.then(function createAssignedUserId() {
						return smbContentTypeGroupTagTypeConfigService.createTagType(_contentTypeGroup.LibraryId, _assignedUserId);
					})
					.then(function createAssignedDate() {
						return smbContentTypeGroupTagTypeConfigService.createTagType(_contentTypeGroup.LibraryId, _assignedDate);
					});
			}
		}

		function saveUserGroups(viewUserGroups, fullUserGroups, editUserGroups) {
			viewUserGroups = viewUserGroups.map(function(g) {
				return smbAclService.createViewAccessRights(_contentTypeGroup.LibraryId, g);
			});

			fullUserGroups = fullUserGroups.map(function(g) {
				return smbAclService.createFullAccessRights(_contentTypeGroup.LibraryId, g);
			});

			editUserGroups = editUserGroups.map(function(g) {
				return smbAclService.createEditAccessRights(_contentTypeGroup.LibraryId, g);
			});

			return smbAclService.saveDocumentGroupAcls(_contentTypeGroup.LibraryId, viewUserGroups.concat(fullUserGroups).concat(editUserGroups));
		}

		function assignUserGroupsToContentTypeGroup(acls)
		{
			return smbLibraryConfigService.assignUserGroupsToLibrary(acls, _contentTypeGroup.LibraryId);
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentConfigDataStores/contentTypeGroupConfigDataStore.js
// module id = 107
// module chunks = 1